import { DynamicComponentLoaderModule } from '@adaptiva/core/loaders';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { SignpostComponentModule } from '@adaptiva/widgets/signpost';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { TimeScaleComponentModule } from '@adaptiva/widgets/time-scale';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RecurringByIntervalComponent } from './recurring-by-interval.component';

@NgModule({
	imports: [
		CommonModule,
		ContainerComponentModule,
		DynamicComponentLoaderModule.forChild(RecurringByIntervalComponent),
		SignpostComponentModule,
		TimeScaleComponentModule,
		TextComponentModule,
	],
	declarations: [
		RecurringByIntervalComponent
	],
	exports: [RecurringByIntervalComponent]
})
export class RecurringByIntervalModule { }
